import React, { useEffect, useState } from "react";
import axios from "axios";

function Masajids() {
  const [masajids, setMasajids] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");

  const districts = [
    "Srikakulam", "Vizianagram", "Visakhapatnam", "Kakinada", "East Godavari",
    "Konaseema", "West Godavari", "Eluru", "Vijayawada", "Krishna",
    "Guntur", "Palnadu", "Bapatla", "Prakasam", "Nellore",
    "Nandayala", "Kurnool", "Anantapur", "SriSathyasai", "Kadapa",
    "Annamayya", "Tirupati", "Chittoor"
  ];

  useEffect(() => {
    const fetchMasajids = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_REQUESTING_API}/api/masjids`
        );
        setMasajids(response.data);
      } catch (error) {
        console.error("Error fetching masajids:", error);
      }
    };

    fetchMasajids();
  }, []);

  const filteredMasajids = selectedDistrict
    ? masajids.filter((masjid) => masjid.district === selectedDistrict)
    : [];

  return (
    <div className="pb-[600px] md:pb-[320px] lg:pb-[420px]">

      {/* Hero Section */}
      <section className="relative w-full h-[600px]">
        <img
          src="/images/mosque3.jpg"
          alt="Mosque"
          className="w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-black mb-6 uppercase tracking-wide">
            Our Masajids
          </h1>
          <p className="text-white/90 max-w-2xl text-sm sm:text-lg lg:text-xl font-light leading-relaxed">
            A place of peace, prayer, and unity — where faith grows and hearts
            connect in the remembrance of Allah.
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="py-14 px-4 md:px-10">

        {/* District Filter */}
        <div className="flex justify-center mb-12">
          <select
            value={selectedDistrict}
            onChange={(e) => setSelectedDistrict(e.target.value)}
            className="border border-gray-300 rounded-xl px-6 py-3 text-lg shadow-sm
                       focus:outline-none focus:ring-2 focus:ring-gray-700"
          >
            <option value="">Select District</option>
            {districts.map((district, index) => (
              <option key={index} value={district}>
                {district}
              </option>
            ))}
          </select>
        </div>

        {/* Cards */}
        {selectedDistrict ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 place-items-center">

            {filteredMasajids.length > 0 ? (
              filteredMasajids.map((masjid) => (
               
               
               <div
  key={masjid._id}
  className="w-full max-w-[340px] sm:max-w-[360px]
             rounded-[32px] overflow-hidden
             bg-white shadow-[0_20px_50px_rgba(0,0,0,0.15)]
             hover:shadow-[0_30px_70px_rgba(0,0,0,0.25)]
             transition-all duration-500"
>
  {/* TOP IMAGE (Bigger - 60% of card) */}
  <div className="relative h-[280px] sm:h-[300px] w-full bg-gradient-to-br from-purple-100 via-purple-50 to-blue-50">
    <img
      src={masjid.image || '/images/default-mosque.jpg'}
      alt={masjid.name}
      className="w-full h-full object-cover"
    />
    {/* Subtle Overlay */}
    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
    
    {/* Heart Icon (Top Right) */}
    <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform cursor-pointer">
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    </div>
    
    {/* District Badge (Top Left) */}
    <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm text-gray-900 text-xs font-bold px-4 py-2 rounded-full shadow-lg">
      {masjid.district}
    </div>
  </div>

  {/* BOTTOM CONTENT (40% of card) */}
  <div className="px-6 py-6 space-y-4">
    {/* Masjid Name */}
    <h3 className="text-xl font-black text-gray-900 leading-tight tracking-tight">
      Masjida Aa {masjid.name}
    </h3>

  


    {/* Tags */}
    <div className="flex gap-2 flex-wrap">
      <span className="border border-gray-300 text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-md uppercase tracking-wide">
        {masjid.district}
      </span>
      <span className="border border-gray-300 text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-md uppercase tracking-wide">
        Andhra Pradesh
      </span>
    </div>

    {/* Description-style text */}
    <p className="text-sm text-gray-600 leading-relaxed">
      A blessed place for prayer and community worship. Connect with faith and peace.
    </p>

    {/* Contact Details in compact style */}
  <div className="space-y-2 text-sm text-gray-700">
  <div className="flex items-center gap-2">
    <i className="fas fa-user  flex-shrink-0 text-[14px]"></i>
    <span className="font-medium truncate">
      {masjid.pointOfContact}
    </span>
  </div>

  <div className="flex items-center gap-2">
    <i className="fas fa-phone-alt flex-shrink-0 text-[14px]"></i>
    <span className="font-medium">
      {masjid.contactNumber}
    </span>
  </div>
</div>


    {/* Bottom Section - Price & Button Style */}
    <div className="flex items-center justify-between pt-2">
      <div>
        <p className="text-xs text-gray-500 uppercase tracking-wide font-semibold">Location</p>
        <p className="text-lg font-black text-gray-900">View Map</p>
      </div>
      
      {masjid.mapUrl && (
                      <a
                        href={masjid.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-4 inline-flex items-center justify-center gap-2
                                   bg-gray-900 text-white text-sm font-semibold
                                   px-6 py-3 rounded-xl
                                   hover:bg-gray-700 transition-all duration-300"
                      >
                        <i className="fas fa-map-location-dot"></i>
                        View on Map
                      </a>
                    )}
    </div>
  </div>
</div>




              ))
            ) : (
              <p className="col-span-full text-center text-gray-500 text-lg">
                No Masajids found in {selectedDistrict}.
              </p>
            )}

          </div>



        ) : (
          <p className="text-center text-gray-500 text-lg mt-10">
            Select a district to view Masajids.
          </p>
        )}
      </div>
    </div>
  );
}

export default Masajids;






// old design 


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function Masajids() {
//   const [masajids, setMasajids] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');

//   const districts = [
//     "Srikakulam", "Vizianagram", "Visakhapatnam", "Kakinada", "East Godavari", 
//     "Konaseema", "West Godavari", "Eluru", "Vijayawada", "Krishna",
//     "Guntur", "Palnadu", "Bapatla", "Prakasam", "Nellore",
//     "Nandayala", "Kurnool", "Anantapur", "SriSathyasai", "Kadapa",
//     "Annamayya", "Tirupati", "Chittoor"
//   ];

//   useEffect(() => {
//     const fetchMasajids = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/masjids`);
//         setMasajids(response.data);
//       } catch (error) {
//         console.error('Error fetching masajids:', error);
//       }
//     };

//     fetchMasajids();
//   }, []);

//   const handleDistrictChange = (e) => {
//     setSelectedDistrict(e.target.value);
//   };

//   const filteredMasajids = selectedDistrict
//     ? masajids.filter(masjid => masjid.district === selectedDistrict)
//     : [];

//   return (
//     <div className=" pb-[600px] md:pb-[320px] lg:pb-[420px]">

//       {/* Hero Section */}
//       <section className="relative w-full h-[600px] ">
//         <img
//           src="/images/mosque3.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-40"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <h1 className="text-white text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">
//             Our Masajids
//           </h1>
//           <p className="text-white max-w-2xl text-lg md:text-xl drop-shadow-md">
//             A place of peace, prayer, and community — our Masjid is a sanctuary where hearts connect, faith strengthens, and lives are uplifted in the remembrance of Allah.
//           </p>
//         </div>
//       </section>

//       {/* Masajids Section */}
//       <div className="py-12 px-6">

//         {/* District Filter */}
//         <div className="flex flex-col md:flex-row justify-center items-center mb-10 gap-6 md:gap-20">
//           {/* <h2 className="text-4xl font-semibold text-gray-800 text-center">
//             Our Masajids
//           </h2> */}

//           <div className="flex flex-col items-center gap-2">
//             <select
//               value={selectedDistrict}
//               onChange={handleDistrictChange}
//               className="border border-gray-300 rounded-md px-6 py-2 text-gray-700 text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
//             >
//               <option value="">Select District</option>
//               {districts.map((district, index) => (
//                 <option key={index} value={district}>
//                   {district}
//                 </option>
//               ))}
//             </select>
//             {/* <p className="text-gray-500 text-xl">Please select a district to view Masajids.</p> */}
//           </div>
//         </div>

//         {/* Masajids Grid */}
//         {selectedDistrict ? (
//           <div className="flex flex-wrap justify-center gap-8">
//             {filteredMasajids.length > 0 ? (
//               filteredMasajids.map((masjid) => (
//                 <div 
//                   key={masjid._id}
//                   className="bg-white w-80 rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center"
//                 >
//                   {/* Image */}
//                   <img 
//                     src={masjid.image || '/images/default-mosque.jpg'} 
//                     alt={masjid.name}
//                     className="h-48 w-full object-cover"
//                   />

//                   {/* Content */}
//                   <div className="p-6 flex flex-col flex-1">
//                     <h3 className="text-xl font-bold text-gray-800 mb-2">{masjid.name}</h3>
//                     <p className="text-gray-600 text-sm mb-1">
//                       <span className="font-semibold">Contact Person:</span> {masjid.pointOfContact}
//                     </p>
//                     <p className="text-gray-600 text-sm mb-1">
//                       <span className="font-semibold">Phone:</span> {masjid.contactNumber}
//                     </p>
//                     <p className="text-gray-600 text-sm mb-4">
//                       <span className="font-semibold">District:</span> {masjid.district}
//                     </p>

//                     {/* Button */}
//                     {masjid.mapUrl && (
//                       <a 
//                         href={masjid.mapUrl} 
//                         target="_blank" 
//                         rel="noopener noreferrer"
//                         className="mt-auto bg-gradient-to-r from-gray-500 to-indigo-600 hover:from-gray-600 hover:to-indigo-700 text-white font-semibold text-sm tracking-wide py-2 px-6 rounded-full transition-all duration-300"
//                       >
//                         View on Map
//                       </a>
//                     )}
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p className="text-center text-gray-500 col-span-full">No Masajids found in {selectedDistrict}.</p>
//             )}
//           </div>
//         ) : (
//           <p className="text-center text-gray-500 mt-10 text-lg">Select a district to view Masajids.</p>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Masajids;

